module.exports = __webpack_public_path__ + "img/Promo.8c63a9b6.png";